export enum JobStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum JobListingType {
  DRIVER = 'DRIVER',
  OFFICE = 'OFFICE',
}

export enum EmploymentType {
  FULL_TIME = 'FULL_TIME',
  PART_TIME = 'PART_TIME',
  CONTRACT = 'CONTRACT',
  TEMPORARY = 'TEMPORARY',
  SEASONAL = 'SEASONAL',
  INTERNSHIP = 'INTERNSHIP',
}

export const EmploymentTypeLabels = {
  [EmploymentType.FULL_TIME]: 'Full-time',
  [EmploymentType.PART_TIME]: 'Part-time',
  [EmploymentType.CONTRACT]: 'Contract',
  [EmploymentType.TEMPORARY]: 'Temporary',
  [EmploymentType.SEASONAL]: 'Seasonal',
  [EmploymentType.INTERNSHIP]: 'Internship',
}

export enum PayUnit {
  PER_MILE = 'PER_MILE',
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
  PER_TASK = 'PER_TASK',
  PER_SHIFT = 'PER_SHIFT',
}

export const PayUnitLabels = {
  [PayUnit.PER_MILE]: 'Per mile',
  [PayUnit.HOURLY]: 'Hourly',
  [PayUnit.DAILY]: 'Daily',
  [PayUnit.WEEKLY]: 'Weekly',
  [PayUnit.MONTHLY]: 'Monthly',
  [PayUnit.ANNUAL]: 'Annual',
  [PayUnit.PER_TASK]: 'Per task',
  [PayUnit.PER_SHIFT]: 'Per shift',
}

export const JobListingTypeLabels = {
  [JobListingType.DRIVER]: 'Driver',
  [JobListingType.OFFICE]: 'Office',
}

export const jobListingTypeOptions: { value: JobListingType; label: string }[] =
  Object.values(JobListingType).map((value) => ({
    value,
    label: JobListingTypeLabels[value],
  }))

export const employmentTypeOptions: {
  value: EmploymentType
  label: string
}[] = Object.values(EmploymentType).map((value) => ({
  value,
  label: EmploymentTypeLabels[value],
}))

export const payUnitOptions: { value: PayUnit; label: string }[] =
  Object.values(PayUnit).map((value) => ({
    value,
    label: PayUnitLabels[value],
  }))
